(() => {
  'use strict';
  if (window.DrpenxHalloweenSite) return;
  const source = document.querySelector('[data-dxh-site-config]');
  let config;
  try { config = JSON.parse(source?.textContent || ''); } catch { return; }
  const start = Date.parse(config.startsAt);
  const end = Date.parse(config.endsAt);
  const serverNow = Number(config.serverNow) * 1000;
  if (!Number.isFinite(start) || !Number.isFinite(end) || !Number.isFinite(serverNow) || start >= end) return;
  const initialTick = performance.now();
  const now = () => serverNow + performance.now() - initialTick;
  const strings = config.strings || {};
  const text = key => typeof strings[key] === 'string' ? strings[key] : '';
  let shopUrl;
  try { shopUrl = new URL(config.shopUrl, location.origin); } catch { return; }
  if (shopUrl.origin !== location.origin) return;
  let frame = 0;
  let timer = 0;
  const scope = document.body;
  if (!scope) return;
  const create = (tag, className, key) => {
    const node = document.createElement(tag);
    node.className = className;
    node.dataset.dxhOwned = key;
    return node;
  };
  const updateText = (node, value) => { if (node.textContent !== value) node.textContent = value; };
  const ensure = (host, key, className, value, placement = 'append', tag = 'p') => {
    let node = [...host.children].find(child => child.dataset.dxhOwned === key);
    if (!node) {
      node = create(tag, className, key);
      if (placement === 'prepend') host.prepend(node); else host.append(node);
    }
    updateText(node, value);
    return node;
  };
  function campaignIsActive() { const time = now(); return config.enabled === true && time >= start && time < end; }
  function markAnnouncement() {
    const bar = scope.querySelector('.announcement, .dxs-announcement');
    if (!bar || !text('announcement')) return;
    bar.dataset.dxhAnnouncement = 'true';
    let note = [...bar.children].find(child => child.dataset.dxhOwned === 'announcement');
    if (!note) { note = create('a', 'dxh-announcement-link', 'announcement'); note.href = shopUrl.href; bar.append(note); }
    updateText(note, text('announcement'));
  }
  function markNavigation() {
    scope.querySelectorAll('[data-home-header] .primary-link, [data-home-menu-tree] a').forEach(link => {
      let pathname;
      try { pathname = new URL(link.href, location.origin).pathname.replace(/\/$/, ''); } catch { return; }
      if (!pathname.endsWith('/collections/sale')) return;
      let badge = [...link.children].find(child => child.dataset.dxhOwned === 'sale');
      if (!badge) { badge = create('span', 'dxh-sale-mark', 'sale'); badge.setAttribute('aria-hidden', 'true'); link.append(badge); }
      updateText(badge, text('saleMark'));
    });
  }
  function markCards() {
    scope.querySelectorAll('[data-cf-card]').forEach(card => {
      if (!card.querySelector('.buy-action')) return;
      ensure(card, 'card', 'dxh-card-note', text('card'));
    });
    scope.querySelectorAll('.system-layout .product .product-bottom > div').forEach(price => {
      if (price.querySelector('.price')) ensure(price, 'home-card', 'dxh-home-note', text('card'), 'append', 'span');
    });
    scope.querySelectorAll('[data-refill-panel] .refill-price').forEach(price => ensure(price, 'home-refill', 'dxh-home-note', text('card'), 'append', 'span'));
    scope.querySelectorAll('[data-home-quickshop-dialog] .quickshop-body').forEach(body => {
      const price = body.querySelector('#quickshop-price');
      if (!price) return;
      const note = ensure(body, 'quickshop', 'dxh-quickshop-note', text('card'));
      if (price.nextElementSibling !== note) price.after(note);
    });
  }
  function markProduct() {
    scope.querySelectorAll('[data-pf-root] .purchase-info').forEach(panel => {
      const price = panel.querySelector('#offer-price');
      if (!price) return;
      let note = [...panel.children].find(child => child.dataset.dxhOwned === 'product');
      if (!note) {
        note = create('div', 'dxh-product-note', 'product');
        note.append(document.createElement('strong'), document.createElement('span'));
        price.after(note);
      }
      updateText(note.children[0], text('productTitle'));
      updateText(note.children[1], text('productCopy'));
    });
    scope.querySelectorAll('.continuing-purchase .continuing-offer').forEach(offer => ensure(offer, 'sticky', 'dxh-sticky-note', text('sticky')));
  }
  function readCart(surface) {
    try { const cart = JSON.parse(surface.querySelector('[data-cf-cart-data]')?.textContent || ''); return Array.isArray(cart.items) ? cart : null; } catch { return null; }
  }
  function markCart() {
    scope.querySelectorAll('[data-cf-surface]').forEach(surface => {
      const empty = surface.querySelector('.empty-state');
      if (empty) {
        const note = ensure(empty, 'cart-empty', 'dxh-cart-note', text('empty'));
        const button = empty.querySelector('a.commerce-button');
        if (button && button.previousElementSibling !== note) button.before(note);
        return;
      }
      const summary = surface.querySelector('.summary-card, .cf-cart-drawer__footer');
      if (!summary) return;
      const cart = readCart(surface);
      const confirmed = surface.dataset.cfStale !== 'true' && cart && (cart.cart_level_discount_applications || []).some(discount => discount.title === 'Halloween 2026' && discount.value_type === 'percentage' && Number(discount.value) === 15 && Number(discount.total_allocated_amount) > 0);
      ensure(summary, 'cart', 'dxh-cart-note', text(confirmed ? 'cartApplied' : 'cartUnconfirmed'), 'prepend');
    });
  }
  function clearCampaign() {
    scope.querySelectorAll('[data-dxh-owned]').forEach(node => node.remove());
    scope.querySelectorAll('[data-dxh-announcement]').forEach(node => node.removeAttribute('data-dxh-announcement'));
  }
  function render() {
    frame = 0;
    const active = campaignIsActive();
    if (scope.dataset.dxhActive !== String(active)) scope.dataset.dxhActive = String(active);
    scope.querySelectorAll('[data-dxh-site-lead]').forEach(node => { node.hidden = !active; });
    if (!active) { clearCampaign(); return; }
    markAnnouncement(); markNavigation(); markCards(); markProduct(); markCart();
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(render); }
  function tick() {
    clearTimeout(timer);
    schedule();
    const time = now();
    const nextBoundary = time < start ? start : end;
    if (time < end) timer = setTimeout(tick, Math.max(100, Math.min(60000, nextBoundary - time + 50)));
  }
  new MutationObserver(records => {
    if (records.some(record => record.type === 'attributes' || !record.target.closest?.('[data-dxh-owned]') && [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === Node.ELEMENT_NODE))) schedule();
  }).observe(scope, { childList: true, attributes: true, attributeFilter: ['data-cf-stale'], subtree: true });
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
  window.addEventListener('pageshow', tick);
  window.DrpenxHalloweenSite = { refresh: schedule, isActive: campaignIsActive };
  render(); tick();
})();
